<template>
  <div v-if="active">
    <slot />
  </div>
</template>


<script>
export default {
  name: 'StationTabContent',
  data() {
    return {
      active: false
    }
  },
  inject: {
    stationTabbedPage: {
      default() {
        return { }
      }
    }
  },
  mounted() {
    this.registerTabContentItem()
  },
  destroyed() {
    this.unregisterTabContentItem()
  },
  methods: {
    registerTabContentItem() {
      this.stationTabbedPage.registerTabContentItem && this.stationTabbedPage.registerTabContentItem(this)
    },
    unregisterTabContentItem() {
      this.stationTabbedPage.unregisterTabContentItem && this.stationTabbedPage.unregisterTabContentItem(this)
    },
  }
}
</script>